// products modules
import axios from 'axios';
import { ZIPCODE_URL, MOBILE_URL, ZIPCODE_URL_NO_LOGIN} from '../../api/url.js';
import Router from '../../router'

// initial state
const state = {
  allGroups: [],
  currentGroup: '',
  search: '',
  device: '',
  homeWithinRadius: null,
  homeRadiusChecked: false,
  checkoutWithinRadius: false,
  checkoutRadiusChecked: false,
  zipcode: '',
  validPurchase: false,
  radiusCheckoutError: '',
  radiusHomeError: '',
  showModal: localStorage.getItem('showModal') || '',
  mobile: false,
  showModalToken: localStorage.getItem('showModalToken') || '',
  componentDisplayOnAccount: 'orders',
  windowHeight: null,
  windowWidth: null,
}

// actions
const actions = {
  fetchGroups: ({ commit }, data) => {
    axios({ url: `${MOBILE_URL}/group`, method: 'GET' })
    .then( res => {
      commit('updateGroups', res.data)
    })
    .catch(err => {

    })
  },

  validateDeliveryRadius(context, address) {
      const config = {
        method: 'get',
        url: ZIPCODE_URL_NO_LOGIN,
      };
      axios(config) 
      .then(response => {
        let found = false;
        response.data.map(code => {
          if (address === code.zipcode) {
            found = true;
          }
        });
        if (Router.history.current.name === 'purchase') {
          context.commit('validateRadiusPurchase', found);
        } else {
          context.commit('validateRadiusHome', found);
          localStorage.setItem('showModalToken', found);
        } 
      }, (err) => {
        if (Router.history.name === 'home') {
          context.commit('homeRadiusError', err);
        } else if (Router.history.name === 'checkout') {
          context.commit('purchaseRadioError', err);
        }
      });
    },
  };

// mutations
const mutations = {
  updateGroups(state, data) {
    state.allGroups = data
  },
  updateCurrentGroup(state, data) {
   state.currentGroup = data
  },
  homeRadiusError(state, payload) {
    state.radiusHomeError = payload;
  },
  radiusCheckoutError(state, payload) {
    state.radiusCheckoutError = payload;
  },
  updateSearchTerm(state, data) {
    state.search = data
  },
  updateDevice(state, payload) {
    state.device = payload;
  },
  validateRadiusHome(state, payload) {
    state.homeWithinRadius = payload;
    state.homeRadiusChecked = true;
  },
  validateRadiusPurchase(state, payload) {
    state.checkoutWithinRadius = payload;
    state.checkoutRadiusChecked = true;
  },
  updateZipCode(state, payload) {
    state.zipcode = payload;
  },
  toggleModal(state, payload) {
    state.showModal = payload;
  },
  toggleTokenModal(state, payload) {
    localStorage.setItem('showModalToken', payload);
  },
  resetHomeWithinRadius(state, payload) {
    state.homeWithinRadius = null;
  },
  handleNavToAccountFromNavbar(state, payload) {
    state.componentDisplayOnAccount = payload;
  },
  mobileDevice(state, payload) {
    state.mobile = payload;
  },
  handleWindowResize(state, payload) {
    state.windowHeight = payload.windowHeight; 
    state.windowWidth = payload.windowWidth; 
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/navbar.js